module.exports = __webpack_public_path__ + "img/News12Logo.eff56580.gif";